/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusFuelOption } from './BonusFuelOption';
import {
    BonusFuelOptionFromJSON,
    BonusFuelOptionFromJSONTyped,
    BonusFuelOptionToJSON,
    BonusFuelOptionToJSONTyped,
} from './BonusFuelOption';
import type { SiteConfigurationKey } from './SiteConfigurationKey';
import {
    SiteConfigurationKeyFromJSON,
    SiteConfigurationKeyFromJSONTyped,
    SiteConfigurationKeyToJSON,
    SiteConfigurationKeyToJSONTyped,
} from './SiteConfigurationKey';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { PaymentMethods } from './PaymentMethods';
import {
    PaymentMethodsFromJSON,
    PaymentMethodsFromJSONTyped,
    PaymentMethodsToJSON,
    PaymentMethodsToJSONTyped,
} from './PaymentMethods';

/**
 * Used for site-wide configuration like promotional banners and reward management.
 * @export
 * @interface SiteConfiguration
 */
export interface SiteConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    updatedAt: number;
    /**
     * 
     * @type {SiteConfigurationKey}
     * @memberof SiteConfiguration
     */
    configKey: SiteConfigurationKey;
    /**
     * 
     * @type {Asset}
     * @memberof SiteConfiguration
     */
    asset?: Asset;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    buttonText?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    description?: string;
    /**
     * 
     * @type {object}
     * @memberof SiteConfiguration
     */
    data?: object;
    /**
     * 
     * @type {boolean}
     * @memberof SiteConfiguration
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfiguration
     */
    business?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConfiguration
     */
    nftGroupings?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConfiguration
     */
    endDate?: number;
    /**
     * 
     * @type {BonusFuelOption}
     * @memberof SiteConfiguration
     */
    bonusFuelType?: BonusFuelOption;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof SiteConfiguration
     */
    phoneNumber?: PhoneNumber;
    /**
     * Indicates if the current date time falls within the configuration's start and end dates
     * @type {boolean}
     * @memberof SiteConfiguration
     */
    isWithinValidDate?: boolean;
    /**
     * 
     * @type {Array<PaymentMethods>}
     * @memberof SiteConfiguration
     */
    paymentMethods?: Array<PaymentMethods>;
}



/**
 * Check if a given object implements the SiteConfiguration interface.
 */
export function instanceOfSiteConfiguration(value: object): value is SiteConfiguration {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('configKey' in value) || value['configKey'] === undefined) return false;
    return true;
}

export function SiteConfigurationFromJSON(json: any): SiteConfiguration {
    return SiteConfigurationFromJSONTyped(json, false);
}

export function SiteConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'configKey': SiteConfigurationKeyFromJSON(json['configKey']),
        'asset': json['asset'] == null ? undefined : AssetFromJSON(json['asset']),
        'url': json['url'] == null ? undefined : json['url'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'data': json['data'] == null ? undefined : json['data'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'value': json['value'] == null ? undefined : json['value'],
        'user': json['user'] == null ? undefined : json['user'],
        'business': json['business'] == null ? undefined : json['business'],
        'nftGroupings': json['nftGroupings'] == null ? undefined : json['nftGroupings'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'bonusFuelType': json['bonusFuelType'] == null ? undefined : BonusFuelOptionFromJSON(json['bonusFuelType']),
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'isWithinValidDate': json['isWithinValidDate'] == null ? undefined : json['isWithinValidDate'],
        'paymentMethods': json['paymentMethods'] == null ? undefined : ((json['paymentMethods'] as Array<any>).map(PaymentMethodsFromJSON)),
    };
}

export function SiteConfigurationToJSON(json: any): SiteConfiguration {
    return SiteConfigurationToJSONTyped(json, false);
}

export function SiteConfigurationToJSONTyped(value?: SiteConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'configKey': SiteConfigurationKeyToJSON(value['configKey']),
        'asset': AssetToJSON(value['asset']),
        'url': value['url'],
        'buttonText': value['buttonText'],
        'title': value['title'],
        'description': value['description'],
        'data': value['data'],
        'isActive': value['isActive'],
        'percentage': value['percentage'],
        'amount': value['amount'],
        'value': value['value'],
        'user': value['user'],
        'business': value['business'],
        'nftGroupings': value['nftGroupings'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'bonusFuelType': BonusFuelOptionToJSON(value['bonusFuelType']),
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'isWithinValidDate': value['isWithinValidDate'],
        'paymentMethods': value['paymentMethods'] == null ? undefined : ((value['paymentMethods'] as Array<any>).map(PaymentMethodsToJSON)),
    };
}

